import { useLanguage } from '@/features/i18n';
import { cn } from '@/lib/utils';

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { language, setLanguage } = useLanguage();

  const isNorwegian = language === 'no';

  return (
    <button
      onClick={() => setLanguage(isNorwegian ? 'en' : 'no')}
      className={cn(
        'relative flex items-center h-8 w-16 rounded-full p-0.5 transition-all duration-200 active:scale-95',
        'bg-neutral-200 dark:bg-neutral-700',
        className
      )}
      title={isNorwegian ? 'Switch to English' : 'Bytt til norsk'}
      aria-label={isNorwegian ? 'Switch to English' : 'Bytt til norsk'}
    >
      {/* Background labels */}
      <span
        className={cn(
          'absolute left-2 text-[10px] font-bold transition-opacity duration-200 select-none pointer-events-none',
          isNorwegian ? 'opacity-0' : 'opacity-50 text-neutral-500 dark:text-neutral-400'
        )}
      >
        NO
      </span>
      <span
        className={cn(
          'absolute right-2 text-[10px] font-bold transition-opacity duration-200 select-none pointer-events-none',
          isNorwegian ? 'opacity-50 text-neutral-500 dark:text-neutral-400' : 'opacity-0'
        )}
      >
        EN
      </span>

      {/* Sliding pill */}
      <span
        className={cn(
          'flex items-center justify-center h-7 w-7 rounded-full bg-white dark:bg-neutral-800 shadow-sm transition-transform duration-200 ease-in-out pointer-events-none',
          isNorwegian ? 'translate-x-0' : 'translate-x-8'
        )}
      >
        <span className="text-[10px] font-bold text-neutral-900 dark:text-white select-none">
          {isNorwegian ? 'NO' : 'EN'}
        </span>
      </span>
    </button>
  );
}
